var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],staticStyle:{"text-decoration":"none"},attrs:{"href":_vm.value,"target":"_empty"}},[_c('v-icon',{attrs:{"size":"20"}},[_vm._v("mdi-download")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }